module.exports = __webpack_public_path__ + "img/page_image_1_4.cce764d4.svg";